import React from 'react';
import { useSelector, useDispatch, connect } from 'react-redux';
import DataSourceModal from './DataSourceModal';
import PropTypes from 'prop-types';
import GeckoRequest from 'services/gecko-request';
import { renderError } from 'services/gecko-error';
import GeckoLocation from 'services/gecko-location';
import {
  GECKO_CONSTS,
  GeckoToastService,
  GeckoModalService,
  GeckoCardTable,
  GeckoModal,
} from 'ui';
import GeckoPagination from 'services/gecko-pagination';
import {
  updateDataSource,
  newDataSource,
  deleteDataSource,
} from 'actions/data_sources';

const DataSources = () => {
  const dataSources = useSelector((state) => state.data_sources);
  const params = useSelector((state) => state.location.params);

  const dispatch = useDispatch();

  const openDataSourceModal = (dataSource) => {
    const isNew = dataSource === undefined;
    const onSave = isNew
      ? (dataSource) => dispatch(newDataSource(dataSource))
      : (dataSource) => dispatch(updateDataSource(dataSource));
    new GeckoModalService().open(() => {
      return <DataSourceModal dataSource={dataSource} onSave={onSave} />;
    });
  };

  const openDataSourceTable = (dataSource) => {
    GeckoLocation.goTo(`/settings/datasources/${dataSource.id}`);
  };

  const deleteSource = (dataSource) => {
    return GeckoRequest.delete(`/models/data_sources/${dataSource.id}`)
      .then(() => {
        new GeckoToastService().success('Data Source removed');
        dispatch(deleteDataSource(dataSource));
        GeckoLocation.reload();
      })
      .catch(renderError);
  };

  const ConfirmDeleteModal = (dataSource) => {
    const confirmDeleteBtns = [
      {
        name: 'Cancel',
        handler: () => new GeckoModalService().close(),
      },
      {
        name: 'Remove Data Source',
        handler: () => {
          new GeckoModalService().close();
          deleteSource(dataSource);
        },
        type: GECKO_CONSTS.BTN_TYPE_DANGER,
      },
    ];

    new GeckoModalService().open(() => {
      return (
        <GeckoModal name={'Remove Data Source'} btns={confirmDeleteBtns}>
          Are you sure you want to remove the Data source?
        </GeckoModal>
      );
    });
  };

  const cols = [
    {
      key: 'name',
      name: 'Name',
      width: '25%',
    },
    {
      key: 'type',
      name: 'Type',
      width: '25%',
    },
    {
      key: 'mail_merge_tag',
      name: 'Mail Merge Tag',
      width: '50%',
    },
    {
      type: GECKO_CONSTS.TABLE_CELL_TYPE_DROPDOWN,
      items: [
        {
          name: 'Edit',
          handler: (row) => openDataSourceModal(row),
        },
        {
          name: 'Remove',
          handler: (row) => ConfirmDeleteModal(row),
        },
      ],
    },
  ];

  const headerBtns = [
    {
      preset: GECKO_CONSTS.BTN_PRESET_ADD,
      handler: () => openDataSourceModal(),
    },
  ];

  const [sources, pagination] = GeckoPagination.paginate({
    page: params.page,
    order_by: 'name',
  })(dataSources);

  return (
    <div className="content-margin">
      <GeckoCardTable
        name="Data Sources"
        cols={cols}
        rows={sources}
        headerBtns={headerBtns}
        rowHandler={openDataSourceTable}
        alert="You don't have any data sources at the moment."
        newLinkHandler={() => openDataSourceModal()}
        pagination={pagination}
      />
    </div>
  );
};

DataSources.contextTypes = {
  location: PropTypes.object,
  history: PropTypes.object,
};

export default DataSources;
